import {
  ForwardedRef,
  forwardRef,
  MouseEvent,
  MutableRefObject,
  useRef,
  useState,
} from 'react';
import { clsx } from 'clsx';

import { IContainerScheduleProps } from '../models/IContainerSchedule';

import styles from './styles.module.scss';

export const ContainerSchedule = forwardRef<
  HTMLDivElement,
  IContainerScheduleProps
>(
  (
    { children, onScroll, setIsScrolledDown, isScrolledDown },
    ref: ForwardedRef<HTMLDivElement>,
  ) => {
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);
    const lastTimeRef = useRef<number>(0);
    const lastXRef = useRef<number>(0);

    const handleMouseDown = (e: MouseEvent<HTMLDivElement>) => {
      setIsDragging(true);
      e.preventDefault();
      const currentRef = ref as MutableRefObject<HTMLDivElement | null>;
      setStartX(e.pageX - (currentRef.current?.offsetLeft || 0));
      setScrollLeft(currentRef.current?.scrollLeft || 0);
      lastTimeRef.current = performance.now();
      lastXRef.current = e.pageX;
    };

    const handleMouseLeave = () => {
      setIsDragging(false);
    };

    const handleMouseUp = () => {
      setIsDragging(false);
    };

    const handleMouseMove = (e: MouseEvent<HTMLDivElement>) => {
      if (!isDragging) return;
      e.preventDefault();
      const currentRef = ref as MutableRefObject<HTMLDivElement | null>;
      if (currentRef.current) {
        const x = e.pageX - (currentRef.current?.offsetLeft || 0);
        const walk = (x - startX) * 0.85;
        currentRef.current.scrollLeft = scrollLeft - walk;
      }
      const now = performance.now();
      lastXRef.current = e.pageX;
      lastTimeRef.current = now;
    };

    return (
      <div
        className={clsx(styles['container-schedule'], {
          [styles['container-schedule_scrolled']]: isScrolledDown,
        })}
        ref={ref}
        onMouseDown={handleMouseDown}
        onMouseLeave={handleMouseLeave}
        onMouseUp={handleMouseUp}
        onMouseMove={handleMouseMove}
        onScroll={() => {
          const currentRef = ref as MutableRefObject<HTMLDivElement | null>;
          if ((currentRef.current?.scrollTop as number) > 50) {
            setIsScrolledDown(true);
          } else {
            setIsScrolledDown(false);
          }
          onScroll();
        }}
      >
        <div
          className={styles['content']}
          style={{ cursor: isDragging ? 'grabbing' : 'default' }}
        >
          {children}
        </div>
      </div>
    );
  },
);
